import styled from 'styled-components';

export const SubText = styled.p`
  color: ${({ theme }) => theme.text.subtext};
  font-size: 13px;
  margin-top: 4px;
`;
